import { InternetAppProps } from "../../../Components/InternetApps/TimeSquareInternetApp/InternetApp";

import Header from "./TimeSquareInternetAssets/Asset 2.png";
import Photo from "./TimeSquareInternetAssets/Asset 3 (1).png";

export const TimeSquareInternetContent: InternetAppProps = {
  headerImage: Header,
  bodyImage: Photo, // Assuming the same photo as the article photo
  logoIcon: "",
  searchBarText: "Search New York Voice",
  introText: `The New York mayoral contest has just got even dirtier. Mayoral Candidate, Alex Cirollo, has been accused of hacking the phones of people close to her opponent, Elijah Ellis.`,
  bodyText: `Elijah Ellis’s campaign team contacted the press earlier this week accusing Cirollo’s team of suspected blackmail. An investigation conducted by the New York Voice has revealed that Cirollo’s team hacked over 100 phone accounts in an attempt to find information that might compromise the Ellis campaign.

Cirollo is being investigated by the New York Independent Electoral Investigation Body (NYIEIB) and is expected to give a statement this weekend responding to the reports. If the NYIEIB find Cirollo guilty of phone hacking, she will be suspended from the race.`,
  website: "www.newyorkvoice.com",
  photoCaption: "",
  articleTitle: "Alex Cirollo embroiled in phone hacking scandal",
  articleDate: "Sunday Aug 18, 2024",
  author: "Written by Lauren McNally",
};
